import { Link, useLocation } from "react-router-dom";

export function BottomNav() {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="flex items-center justify-around h-16 px-4">
        {/* Home */}
        <Link
          to="/dashboard"
          className="flex items-center justify-center w-12 h-12 rounded-lg transition-opacity hover:opacity-80"
        >
          <img 
            src="/home-button.svg" 
            alt="Home" 
            className="h-12 w-12"
          />
        </Link>

        {/* Camera - Remix Icon */}
        <Link
          to="/book/step-1"
          className={`flex items-center justify-center w-12 h-12 rounded-lg transition-colors ${
            isActive('/book/step-1')
              ? 'bg-orange-500 text-white'
              : 'text-gray-600'
          }`}
        >
          <i className="ri-camera-3-line text-2xl"></i>
        </Link>

        {/* Profile - Remix Icon */}
        <Link
          to="/dashboard/profile"
          className={`flex items-center justify-center w-12 h-12 rounded-lg transition-colors ${
            isActive('/dashboard/profile')
              ? 'bg-orange-500 text-white'
              : 'text-gray-600'
          }`}
        >
          <i className="ri-user-3-line text-2xl"></i>
        </Link>
      </div>
    </nav>
  );
}

